define('gigaset_csp/components/order/repair/form/address',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({
		block: null,

		addressChooserBlock:	null,

		form:				null,
		validator:			null,
		submitButton:		null,
		createAddress:		null,
		createAddressWrap:	null,

		config:				null,

		$init: function() {
			var self = this;

			this.block = BEM.block("csp-repair-order-register-form-address");
			this.addressChooserBlock = BEM.block("customer-address-chooser");

			this.config = this.block.data("config");

			this.form = this.block.getElements("form");
			this.submitButton = this.block.getElements("submit-button");
			this.validator = new Validation(this.form.get(0), {
				onSubmit: false
			});

			this.createAddressWrap = this.block.getElements("new-address");

			this.createAddress = this.block.getElements("create-delivery-address");
			this.createAddress.on("change", function() {
				if (this.checked) {
					if (this.value != 0) {
						self._showCreateAddressForm();
						self.addressChooserBlock.addModifier("disabled");
					} else {
						self._hideCreateAddressForm();
						self.addressChooserBlock.removeModifier("disabled");
					}
				}
			});

			this.form.on("submit", $.proxy(this._onFormSubmit, this));
		},

		_showCreateAddressForm: function() {
			this.createAddressWrap.css("display", "block");
		},

		_hideCreateAddressForm: function() {
			this.createAddressWrap.css("display", "none");
		},

		_onFormSubmit: function(e) {
			var validateForm = false;

			this.createAddress.each(function() {
				if (this.checked && this.value != 0) {
					validateForm = true;
					return false;
				}
			});

			if (validateForm && !this.validator.validate()) {
				e.preventDefault();
				return;
			}

			this.block.addModifier("submitting");
			this.submitButton.button("loading");
		}
	});
});
